import { useState } from "react";
import { useSelector } from "react-redux";
import {
  Welcome,
  Select,
  Typography,
  DateCTA,
  NewDateFIlterModal as DateFilterModal,
} from "components";
import {
  getAllStatistics,
  setOnboardingDashboardUserType,
} from "redux/actions/dashboard/onboardingDashboardActions";
import { hasPermission, isAdminUser } from "utils/helper";
import { permissions } from "utils/permissions";

const DashboardOnboardingHeader = () => {
  const [dates, setDates] = useState({
    dateFrom: "",
    dateTo: "",
  });

  const [openDateModal, setOpenDateModal] = useState(false);

  const { dateFrom, dateTo } = dates;

  const {
    user: { user },
    onboarding: { userType, regStatus, agentAggregatorRatio },
  } = useSelector((state) => ({
    user: state.user,
    onboarding: state.onboardingReducer,
  }));

  const handleModalClose = () => setOpenDateModal(false);

  const handleUserTypeChange = (e) => {
    setOnboardingDashboardUserType(e.target.value);
  };

  const handleDateSubmit = () => {
    const statsInfo = {
      userType,
      dates,
      isAdminUser: isAdminUser(user),
      statusRegions: regStatus.regionCode,
      ratioRegions: agentAggregatorRatio.regionCode,
    };
    getAllStatistics(statsInfo);
    handleModalClose();
  };

  const getUserTypes = () => {
    const userTypes = [];

    if (hasPermission(permissions.canSeeUserManagement, user.authorities))
      userTypes.push(
        { label: "Agent", value: "AGENT" },
        { label: "Aggregator", value: "AGGREGATOR" }
      );

    if (hasPermission(permissions.canSeeUserManagementAdmin, user.authorities))
      userTypes.push({ label: "Admin", value: "ADMIN" });
    return userTypes;
  };

  return (
    <div className="onboarding-stats-container">
      <div className="d-flex flex-column flex-md-row justify-content-between align-content-center">
        <Welcome />

        {isAdminUser(user) && (
          <div className="d-flex mt-4 select-container align-items-center">
            <Typography variant="caption1" state="primary">
              Choose User Type:
            </Typography>{" "}
            <Select
              required={false}
              value={userType}
              options={getUserTypes()}
              name="userType"
              onChange={handleUserTypeChange}
            />
          </div>
        )}
      </div>
      <div className="mt-3">
        <div className="d-flex align-items-center cursor-pointer">
          <Typography variant="caption0">Choose Date:</Typography>{" "}
          {/* <BiCalendar fontSize="10px" style={{ marginLeft: ".2rem" }} /> */}
          &nbsp;
          <DateCTA onClick={() => setOpenDateModal(true)} />
        </div>
      </div>
      <DateFilterModal
        dateFrom={dateFrom}
        dateTo={dateTo}
        openDateModal={openDateModal}
        onClose={handleModalClose}
        handleFromChange={(val) => setDates({ ...dates, dateFrom: val })}
        handleToChange={(val) => setDates({ ...dates, dateTo: val })}
        onButtonClick={handleDateSubmit}
      />
    </div>
  );
};

export default DashboardOnboardingHeader;
